export const formulaAddressParseRegex =
  /((('([a-zA-Z0-9 ]|[-!$%^&@()_+|~=`{}:";<>,.])+')|(([a-zA-Z0-9])+))!)?((\$*[A-Z]+\$*[1-9]*[0-9]*):(\$*[A-Z]+\$*[1-9]*[0-9]*)|(\$*[A-Z]+\$*[1-9]*[0-9]*))/g;

export const singleCellRegex = /^[A-Z]+\d+$/;

export const rowAddressRegex = /^\d+:\d+$/;

export const columnAddressRegex = /^[A-Z]+:[A-Z]+$/;

export const cellRangeRegex = /^[A-Z]+\d+:[A-Z]+\d+$/;

export const RANGE_OPERATOR = ':';
export const ABSOLUTE_OPERATOR = '$';

export const ALL_WHITESPACE_REGEX = '\\s+';
export const ODFF_WHITESPACE_REGEX = '[ \\t\\n\\r]+';

export const UNICODE_LETTER_REGEX = 'A-Za-z\u00C0-\u02AF';
export const NON_RESERVED_CHAR_REGEX = `${UNICODE_LETTER_REGEX}0-9_.`;

export const UNQUOTED_SHEET_NAME_REGEX = `[${UNICODE_LETTER_REGEX}0-9_]+`;
export const QUOTED_SHEET_NAME_REGEX = "'(((?!').|'')*)'";
export const SHEET_NAME_REGEX = `(${UNQUOTED_SHEET_NAME_REGEX}|${QUOTED_SHEET_NAME_REGEX})!`;

export const CELL_PATTERN_WITHOUT_SHEET = `\\${ABSOLUTE_OPERATOR}?[A-Za-z]+\\${ABSOLUTE_OPERATOR}?[0-9]+`;

export const CELL_REFERENCE_REGEX = `(${SHEET_NAME_REGEX})?\\${ABSOLUTE_OPERATOR}?[A-Za-z]+\\${ABSOLUTE_OPERATOR}?[0-9]+`;
export const CELL_REFERENCE_WITHOUT_SHEET_REGEX = `\\${ABSOLUTE_OPERATOR}?[A-Za-z]+\\${ABSOLUTE_OPERATOR}?[0-9]+`;

export const COLUMN_REFERENCE_REGEX = `(${SHEET_NAME_REGEX})?\\${ABSOLUTE_OPERATOR}?[A-Za-z]+`;
export const ROW_REFERENCE_REGEX = `(${SHEET_NAME_REGEX})?\\${ABSOLUTE_OPERATOR}?[0-9]+`;
export const R1C1_CELL_REFERENCE_REGEX = '[rR][0-9]*[cC][0-9]*';
export const CELL_REFERENCE_WITH_NEXT_CHAR_REGEX = `(${CELL_REFERENCE_REGEX})[^${NON_RESERVED_CHAR_REGEX}]`;

export const COLUMN_RANGE_REGEX = `${COLUMN_REFERENCE_REGEX}${RANGE_OPERATOR}${COLUMN_REFERENCE_REGEX}`;
export const ROW_RANGE_REGEX = `${ROW_REFERENCE_REGEX}${RANGE_OPERATOR}${ROW_REFERENCE_REGEX}`;

export const CELL_RANGE_REGEX = `${CELL_REFERENCE_REGEX}${RANGE_OPERATOR}${CELL_REFERENCE_WITHOUT_SHEET_REGEX}`;

export const cellAdressRegex = new RegExp(
  `^(${SHEET_NAME_REGEX})?(\\${ABSOLUTE_OPERATOR}?)([A-Za-z]+)(\\${ABSOLUTE_OPERATOR}?)([0-9]+)$`
);

export const columnRegex = new RegExp(
  `^(${SHEET_NAME_REGEX})?(\\${ABSOLUTE_OPERATOR}?)([A-Za-z]+)$`
);
export const rowRegex = new RegExp(
  `^(${SHEET_NAME_REGEX})?(\\${ABSOLUTE_OPERATOR}?)([0-9]+)$`
);

export const CopiedCellFormula = new RegExp(
  /([RC]\[-?\d+\]C\[-?\d+\]|R\[-?\d+\]C\[-?\d+\]|R\d+C\d+|C\[-?\d+\]:C\[-?\d+\])/g
);

// /(R(-?\d+)?)?(C(-?\d+)?)?:?(R(-?\d+)?)?(C(-?\d+)?)/
// /(R\[-?\d+\]|R\d+|C\[-?\d+\]|C\d+)/g For R1 C2 as a separate

// export const RANGE_OPERATOR = ':';
// export const ABSOLUTE_OPERATOR = '$';

// export const ALL_WHITESPACE_PATTERN = '\\s+';
// export const ODFF_WHITESPACE_PATTERN = '[ \\t\\n\\r]+';

// export const UNICODE_LETTER_PATTERN = 'A-Za-z\u00C0-\u02AF';
// export const NON_RESERVED_CHARACTER_PATTERN = `${UNICODE_LETTER_PATTERN}0-9_.`;

// export const UNQUOTED_SHEET_NAME_PATTERN = `[${UNICODE_LETTER_PATTERN}0-9_]+`;
// export const QUOTED_SHEET_NAME_PATTERN = "'(((?!').|'')*)'";
// export const SHEET_NAME_PATTERN = `(${UNQUOTED_SHEET_NAME_PATTERN}|${QUOTED_SHEET_NAME_PATTERN})!`;

// export const CELL_REFERENCE_PATTERN = `(${SHEET_NAME_PATTERN})?\\${ABSOLUTE_OPERATOR}?[A-Za-z]+\\${ABSOLUTE_OPERATOR}?[0-9]+`;
// export const COLUMN_REFERENCE_PATTERN = `(${SHEET_NAME_PATTERN})?\\${ABSOLUTE_OPERATOR}?[A-Za-z]+`;
// export const ROW_REFERENCE_PATTERN = `(${SHEET_NAME_PATTERN})?\\${ABSOLUTE_OPERATOR}?[0-9]+`;
// export const R1C1_CELL_REFERENCE_PATTERN = '[rR][0-9]*[cC][0-9]*';
// export const CELL_REFERENCE_WITH_NEXT_CHARACTER_PATTERN = `(${CELL_REFERENCE_PATTERN})[^${NON_RESERVED_CHARACTER_PATTERN}]`;

// export const NAMED_EXPRESSION_PATTERN = `[${UNICODE_LETTER_PATTERN}_][${NON_RESERVED_CHARACTER_PATTERN}]*`;

// export const ColumnRange = `${COLUMN_REFERENCE_PATTERN}${RANGE_OPERATOR}${COLUMN_REFERENCE_PATTERN}`;
// export const RowRange = `${ROW_REFERENCE_PATTERN}${RANGE_OPERATOR}${ROW_REFERENCE_PATTERN}`;

// Experimental regex not yet tested
const dateFormatRegex =
  /(\\.|dd|DD|d|D|mm|MM|m|M|YYYY|YY|yyyy|yy|HH|hh|H|h|ss(\.(0+|s+))?|s|AM\/PM|am\/pm|A\/P|a\/p|\[mm]|\[MM]|\[hh]|\[HH])/g;
const numberFormatRegex = /(\\.|[#0]+(\.[#0]*)?)/g;
